import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Search, AddCircle, PlaceOutlined} from '@material-ui/icons';
import {Grid, InputBase} from '@material-ui/core';
import Header from 'Components/lto/common/Header';
import BasicButton from 'Components/common/BasicButton';
// Actions
import {
    getSearchHistory,
    updateProductSearchFields,
    addCart,
    getQuote,
    getCustomerQuote,
    getCartCount,
    operationLog,
    batchAddCart,
    updateFromProductSearch,
} from 'Actions/order';
import {openNotification} from 'Actions/notification';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';
import {loadLanguage} from 'Utils/jwtUtil';
import LabelInput from 'Components/common/LabelInput';
import Counter from 'Components/counter/Counter';
import Anchor from 'Components/common/Anchor';
import {PURCHASE_ORDER_MODE} from 'Utils/constant';

class ProductSearchPage extends Component {
    state = {
        searchValue: '',
        pageLoad: true,
        displayTMProduct: false,
        isDemoSite: false,
        isQuoteInfor: false,
        quickAddSkuValue: '',
        quickAddSkuQuantity: 1,
    };

    componentWillMount() {
        this.props.getSearchHistory();

        this.props.getCartCount(this.props.localData.customerEmail);
        this.setState({searchValue: this.props.searchValue});
    }

    // Back Button Event Action
    backEvent = () => {
        if (this.props.localData.isProxyProcess) {
            this.props.history.goBack();
        } else {
            this.props.history.push('/purchase/productList', {
                customerEmail: util.getPurchaseCustomerEmail(),
                customerName: util.getPurchaseCustomerName(),
                fromProductSearchPage: true,
            });
        }
    };

    handleSearch = (event) => {
        this.setState({searchValue: event.target.value});
        this.props.updateProductSearchFields(event.target.value);
    };

    keyDown = (event) => {
        if (event.keyCode === 13) {
            console.log(
                'util.getPurchaseOrderMode()=================================',
                util.getPurchaseOrderMode(),
            );
            this.handleSearch(event);
            event.currentTarget.blur();
            if (this.props.localData.isProxyProcess) {
                this.props.history.goBack();
            } else {
                this.props.history.push('/purchase/productList', {
                    type: 'Search Results',
                    customerEmail: util.getPurchaseCustomerEmail(),
                    customerName: util.getPurchaseCustomerName(),
                    fromProductSearchPage: true,
                });
            }
        }
    };

    cancelSearch = () => {
        this.setState({searchValue: ''});
        this.props.updateProductSearchFields('');
        this.props.updateFromProductSearch(true);

        if (this.props.localData.isProxyProcess) {
            this.props.history.goBack();
        } else {
            this.props.history.push('/purchase/productList', {
                customerEmail: util.getPurchaseCustomerEmail(),
                customerName: util.getPurchaseCustomerName(),
                fromProductSearchPage: true,
            });
        }
    };

    clickSearchKey = (keyward, searchType) => {
        let type;
        if (searchType && searchType === 'Hot Searches') {
            type = 'Hot Searches';
        } else {
            type = 'Recent Searches';
        }
        this.setState({searchValue: keyward});
        this.props.updateProductSearchFields(keyward);
        if (this.props.localData.isProxyProcess) {
            this.props.history.goBack();
        } else {
            this.props.history.push('/purchase/productList', {
                type,
                customerEmail: util.getPurchaseCustomerEmail(),
                customerName: util.getPurchaseCustomerName(),
                fromProductSearchPage: true,
            });
        }
    };

    // Hide API Get Loading
    hideloading = () => {
        this.setState({
            pageLoad: false,
        });
    };

    getQuote = (param) => {
        this.props.getCustomerQuote(
            param,
            this.props.localData,
            this.quoteCallback,
        );
        this.props.operationLog({
            opTarget: 'view_sku_promo_search',
            opContent: param,
            opReqUrl: 'api/quote/sku',
        });
    };

    quoteCallback = (res) => {
        if (res.status === 'success' && res.data.length !== 0) {
            this.setState({
                isQuoteInfor: true,
            });
        } else if (res.status === 'success' && res.data.length === 0) {
            this.props.openNotification(
                T('notification_quote_null'),
                'success',
            );
        } else {
            this.props.openNotification(
                T('notification_get_quote_failed'),
                'success',
            );
        }
    };

    viewSkuDetailSearchOperation = (sku) => {
        this.props.operationLog({
            opTarget: 'view_sku_detail_search',
            opContent: sku,
        });
    };

    // Input quick add sku Change
    handleQuickAddSkuChange = (name, value) => {
        this.setState({[name]: value});
    };

    quickAddSkuQuantityChange = (value) => {
        if (value <= 1) {
            this.setState({
                quickAddSkuQuantity: 1,
            });
        } else {
            this.setState({
                quickAddSkuQuantity: value,
            });
        }
    };

    quickAddSkuHandle = () => {
        const {quickAddSkuValue, quickAddSkuQuantity} = this.state;
        const {localData} = this.props;

        if (quickAddSkuValue && quickAddSkuValue.trim()) {
            this.props
                .batchAddCart([
                    {
                        productId: '',
                        customerEmail: localData.customerEmail,
                        quantity: quickAddSkuQuantity,
                        sku: quickAddSkuValue.trim(),
                    },
                ])
                .then((res) => {
                    this.props.openNotification(
                        T('quick_add_sku_success'),
                        'success',
                    );
                    this.setState({
                        quickAddSkuQuantity: 1,
                        quickAddSkuValue: '',
                    });
                })
                .catch((err) => {
                    if (err.status === 'invalid_sku_price') {
                        this.props.openNotification(
                            T('notification_invalid_sku_price', [
                                quickAddSkuValue.trim(),
                            ]),
                        );
                    } else if (err.status === 'no_content') {
                        this.props.openNotification(
                            T('quickly_add_sku_no_sku', [
                                quickAddSkuValue.trim(),
                            ]),
                        );
                    } else if (err.status === 'no_sku_permission') {
                        this.props.openNotification(
                            T('other_division_no_perssion', [err.message]),
                        );
                    } else if (err.status === 'invalid_erpType') {
                        this.props.openNotification(
                            T('quickly_add_sku_is_fsbio'),
                        );
                    }
                });
        } else {
            this.props.openNotification(T('sku_is_not_null'));
        }
    };

    getPurchaseOrderMode = () => {
        let purchaseOrderMode = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            purchaseOrderMode = routerState.purchaseOrderMode;
        }
        return purchaseOrderMode;
    };

    render() {
        const {
            searchValue,
            pageLoad,
            isQuoteInfor,
            isDemoSite,
            displayTMProduct,
            quickAddSkuValue,
            quickAddSkuQuantity,
        } = this.state;
        const {
            cartCount,
            searchHistoryList,
            quoteInfor,
            quoteCustomerInfor,
            searchProductList,
            listLoaded,
            searchProductLoadingMore,
            tmProductList,
            localData,
        } = this.props;
        const chooseProductList = displayTMProduct
            ? tmProductList
            : searchProductList;
        const productAbyss = displayTMProduct
            ? true
            : chooseProductList.pageNum >= chooseProductList.pageTotal;
        let lang = loadLanguage();
        return (
            <div className="product-search lto-product-search">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    increment={0}
                    backEvent={this.backEvent}
                    noHomeButton={true}
                    hasShoppingCart={true}
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    productSearcheFlag={true}
                    ltoPageTitle={
                        util.getPurchaseOrderMode() ===
                        PURCHASE_ORDER_MODE.ONLINE
                            ? T('lto_purchase_order_line_up')
                            : T('lto_purchase_order_line_down')
                    }
                    cartCount={cartCount}>
                    <Grid
                        className="page-search-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="customer-email-content"
                                item
                                xs={11}>
                                <img
                                    src={
                                        new URL(
                                            'Images/customer_icon.svg',
                                            import.meta.url,
                                        ).href
                                    }
                                    alt=""
                                />
                                <label className="text-ellipsis">
                                    {util.getPurchaseCustomerName()}
                                </label>
                                <label className="text-ellipsis">
                                    {util.getPurchaseCustomerEmail()}
                                </label>
                            </Grid>
                        )}

                        <Grid className="shipto-and-sc" item xs={11}>
                            <Grid
                                className="left-content"
                                item
                                xs={4}
                                testid="product_search_header_ship_to_number">
                                <img
                                    src={
                                        new URL(
                                            'Images/ST.svg',
                                            import.meta.url,
                                        ).href
                                    }
                                    alt=""
                                />
                                {localData.shipToNum}
                            </Grid>
                            <Grid
                                className="supply-center-title text-ellipsis"
                                item
                                xs={7}>
                                <PlaceOutlined />
                                <span className="text-ellipsis">
                                    {localData.scName}
                                </span>
                            </Grid>
                        </Grid>
                        <Grid className="page-search" item xs={10}>
                            <div className="search-icon">
                                <Search />
                            </div>
                            <form>
                                <InputBase
                                    // title={'searchValue'}
                                    placeholder={T('enterProductName')}
                                    className="search-input"
                                    type={'search'}
                                    value={searchValue}
                                    onKeyDown={this.keyDown}
                                    onChange={this.handleSearch}
                                    inputProps={{
                                        testid: 'productSearchInput',
                                    }}
                                />
                            </form>
                        </Grid>
                        <Grid
                            className={util.getClassName({
                                'page-search-btn': true && lang !== 'EN',
                                'en-page-search-btn': true && lang === 'EN',
                            })}
                            item
                            xs={2}>
                            <BasicButton
                                className="search-cancel"
                                disabled={false}
                                onClickOfSingleTap={() => this.cancelSearch()}>
                                <span>{T('cancel')}</span>
                            </BasicButton>
                        </Grid>
                    </Grid>
                </Header>

                <div className="content">
                    {searchHistoryList && searchHistoryList.length > 0 ? (
                        <section className="content-box">
                            {searchHistoryList &&
                            searchHistoryList.length > 0 ? (
                                <div>
                                    <div className="title">
                                        {T('porduct_search_history')}
                                    </div>
                                    <ul className="keyward-list">
                                        {searchHistoryList &&
                                            searchHistoryList.map((item, i) => {
                                                return (
                                                    <li key={i}>
                                                        <BasicButton
                                                            className="keyward"
                                                            disabled={false}
                                                            onClickOfSingleTap={() =>
                                                                this.clickSearchKey(
                                                                    item,
                                                                )
                                                            }>
                                                            <span>{item}</span>
                                                        </BasicButton>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            ) : null}
                        </section>
                    ) : null}

                    <Grid className="quick-sku-container">
                        <Grid className="quick-add-product-title">
                            <Grid
                                className={util.getClassName({
                                    'quick-add-product-title-area':
                                        true && lang !== 'EN',
                                    'en-quick-add-product-title-area':
                                        true && lang === 'EN',
                                })}>
                                {/* <img
                                    alt=""
                                    src={new URL('Images/icon-hot.png', import.meta.url).href}
                                /> */}
                                <AddCircle className="quick-add-sku-icon"></AddCircle>
                                <span className="quick-add-product-line">
                                    {T('shopping_cart_quickly_add_product')}
                                </span>
                            </Grid>
                        </Grid>

                        <div className="add-sku-container">
                            <div className="sku-rows">
                                <label className="required-label">*</label>
                                <LabelInput
                                    defaultValue={quickAddSkuValue}
                                    title={'quickAddSkuValue'}
                                    placeholder={T('backup_please_input_sku')}
                                    inputValid={this.handleQuickAddSkuChange}
                                    type="text"
                                />
                                <Counter
                                    defalutValue={quickAddSkuQuantity}
                                    inputValid={this.quickAddSkuQuantityChange}
                                    options={{min: 1}}
                                />
                                <div className="add-sku-label">
                                    <Anchor
                                        className="add-quick-sku-a"
                                        onClickOfSingleTap={() =>
                                            this.quickAddSkuHandle()
                                        }>
                                        <span className="add-quick-sku-btn">
                                            {T('host_abnormal_add')}
                                        </span>
                                    </Anchor>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {order, localData} = state;
    return {
        cartCount: order.cartCount,
        searchValue: order.searchValue,
        searchHistoryList: order.searchHistoryList.data,
        localData: localData,
        quoteInfor: order.quoteInfor.data,
        quoteCustomerInfor: order.quoteCustomerInfor.data,
        listLoaded: order.searchProductListLoaded,
        searchProductLoadingMore: order.searchProductLoadingMore,
        tmProductList: order.tmProductList,
        searchProductList: order.searchProductList,
    };
};

const mapDispatchToProps = {
    getSearchHistory,
    updateProductSearchFields,
    getQuote,
    getCustomerQuote,
    openNotification,

    addCart,
    getCartCount,
    operationLog,
    batchAddCart,
    updateFromProductSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSearchPage);
